import { ListSearch, ModuleSubmissionV1, ModuleUpdate, ModuleV1Read, UpdateAndSubmitData } from '@ca/core/models';
import { createAction, props } from '@ngrx/store';

const prefix = '[ModuleDetails Page]';

export const deleteMyModule = createAction(`${prefix} Delete MyModule`, props<{ module: ModuleV1Read }>());
export const loadMyModules = createAction(`${prefix} Load MyModules`, props<{ query?: ListSearch | undefined; isReloadEnforced?: boolean }>());
export const publishModule = createAction(`${prefix} Publish MyModule`, props<{ submissionData: ModuleSubmissionV1 }>());
export const updateAndSubmitModule = createAction(`${prefix} Update And Publish MyModule`, props<{ data: UpdateAndSubmitData }>());
export const updateLatestPublicVersion = createAction(`${prefix} Update MyModule LatestPublic Version`, props<{ moduleUpdateModel: ModuleUpdate }>());
export const updateMyModule = createAction(`${prefix} Update MyModule`, props<{ moduleUpdateModel: ModuleUpdate }>());
